<div class="menu-section" (click)="onOpen()">
  <a [routerLink]="sectionRoute" class="menu-section__link">
    <atom-icon class="menu-section__icon" [iconClass]="sectionIcon" [iconColor]="sectionIconColor"/>
    <span class="menu-section__title">{{ 'MENU.' + sectionTitle | translate }}</span>
  </a>
    <atom-icon *ngIf="isDeployable" [iconClass]="'fa-solid fa-caret-down'" [iconColor]="'white'" class="menu-section__icon--arrow" />
</div>

